import { FormControlLabel } from '@material-ui/core'
import React, { useState } from 'react'
import { Trans, WithTranslation, withTranslation } from 'react-i18next'
import ToolbarDesktopWrapper from '../../../../components/Calendar/BookingCalendar/Toolbar/ToolbarDesktopWrapper'
import Checkbox from '../../../../components/FormBuilder/Checkbox/Checkbox'
import Button from '../../../../components/Template/Button'
import Label from '../../../../components/Template/Sidebar/Label'
import { IToolbarProps } from './Toolbar'
import useIsScope from '../../../../hooks/useIsScope'
import { PermissionScope } from '../../../Employees'
import { useDispatch, useSelector } from 'react-redux'
import { getUserSummary } from '../../../../reducers/userObject/selectors/settings'
import { isNewPremiumLicenseValid } from '../../../../reducers/userAccount/selectors/license'
import { PopoveredIcon2 } from '../../../../components/PopoveredIcon/PopoveredIcon'
import { isUserNewPackage } from '../../../../reducers/userAccount/selectors/userAccount'

function ToolbarDesktop({
  toggleSummary,
  openAddRoomModal,
  summary,
  size = 1,
  openAddReservationModal,
}: IToolbarDektopDispatch & WithTranslation & IToolbarProps) {
  const dispatch = useDispatch()
  const scope = useIsScope({
    room: [PermissionScope.SCOPE_CAN_EDIT_ROOMS],
    reservation: [PermissionScope.SCOPE_CAN_EDIT_RESERVATIONS],
  })
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const summarySettings = useSelector(getUserSummary)
  const newPremium = useSelector(isNewPremiumLicenseValid)
  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)

  const handlePopoverOpen = event => {
    event.preventDefault()
    event.stopPropagation()
    setPopoverAnchor(event.currentTarget)
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    dispatch({
      type: 'toggle left sidebar',
      isSidebarOpen: false,
      isSidebarBlock: false,
    })
    setPopoverAnchor(null)
  }

  return (
    <ToolbarDesktopWrapper size={size}>
      {scope.room && (
        <Button
          size={size}
          className={'calendar-button-toolbar-add_room'}
          onClick={openAddRoomModal}
          outline={true}
          data-cy={'add-room-calendar-button'}
        >
          <Trans i18nKey={'add_room'} />
        </Button>
      )}
      {Object.values(summarySettings || {}).some(Boolean) && (
        <FormControlLabel
          style={{ marginLeft: `${30 * size}px` }}
          control={
            <Checkbox
              size={size}
              onChange={toggleSummary}
              checked={summary}
              value={summary}
            />
          }
          label={
            <Label size={size}>
              {' '}
              <Trans i18nKey={'summary'} />
            </Label>
          }
        />
      )}

      {scope.reservation && (
        <Button
          size={size}
          primary
          style={{
            position: 'absolute',
            right: `${10 * size}px`,
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
          onClick={
            (newPremium && isNewPremiumPriceGroup) || !isNewPremiumPriceGroup
              ? openAddReservationModal
              : handlePopoverOpen
          }
          data-cy={'add-reservation-calendar-button'}
          disabled={!newPremium && isNewPremiumPriceGroup}
        >
          {!newPremium && isNewPremiumPriceGroup && (
            <PopoveredIcon2
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              variant={'white'}
              anchorEl={popoverAnchor}
              onClose={handlePopoverClose}
            />
          )}
          <Trans i18nKey={'add_reservation'}>Dodaj rezerwację</Trans>
        </Button>
      )}
    </ToolbarDesktopWrapper>
  )
}

export default withTranslation()(ToolbarDesktop)

export interface IToolbarDektopDispatch {
  toggleSummary?: () => void
  openAddRoomModal: () => void
  openAddReservationModal: () => void
  size?: number
}
